import { coreConstants } from "../constants/core.constants";
import { coreService } from "../services/core.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message } from "../../../_constants";

export const coreActions = {
  getCoreIssuers,
  getCoreDomains,
  getCoreCurrencies
};

function getCoreDomains(requestParams) {
  return async dispatch => {
    dispatch(request(requestParams));
    try {
      const response = await coreService.getCoreDomains(requestParams);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request(requestParams) {
    return { type: coreConstants.GET_CORE_DOMAINS_REQUEST, requestParams };
  }
  function success(response) {
    return { type: coreConstants.GET_CORE_DOMAINS_SUCCESS, response };
  }
  function failure(error) {
    return { type: coreConstants.GET_CORE_DOMAINS_FAILURE, error };
  }
}

function getCoreCurrencies() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await coreService.getCoreCurrencies();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CORE_CURRENCIES
        )
      );
    }
  };

  function request() {
    return { type: coreConstants.GET_CORE_CURRENCIES_REQUEST };
  }
  function success(response) {
    return { type: coreConstants.GET_CORE_CURRENCIES_SUCCESS, response };
  }
  function failure(error) {
    return { type: coreConstants.GET_CORE_CURRENCIES_FAILURE, error };
  }
}

function getCoreIssuers() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await coreService.getCoreIssuers();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CORE_ISSUERS
        )
      );
    }
  };

  function request() {
    return { type: coreConstants.GET_CORE_ISSUERS_REQUEST };
  }
  function success(response) {
    return { type: coreConstants.GET_CORE_ISSUERS_SUCCESS, response };
  }
  function failure(error) {
    return { type: coreConstants.GET_CORE_ISSUERS_FAILURE, error };
  }
}
